import {
  CONNECTION_TREND_DAY_OPTIONS,
  DEFAULT_CONNECTION_TREND_DAYS,
  type ConnectionTrendDayOption,
} from './connectionDashboard';

const DASHBOARD_TREND_DAYS_KEY = 'engine-dashboard-trend-days';

const LEGACY_TREND_DAYS_KEYS = [
  'engine-dashboard-network-reach-trend-days',
  'engine-dashboard-engagements-trend-days',
  'engine-dashboard-subscriber-total-trend-days',
] as const;

function isValidTrendDay(value: unknown): value is ConnectionTrendDayOption {
  return typeof value === 'number' && (CONNECTION_TREND_DAY_OPTIONS as readonly number[]).includes(value);
}

export function readDashboardTrendDays(): ConnectionTrendDayOption {
  try {
    const raw = localStorage.getItem(DASHBOARD_TREND_DAYS_KEY);
    if (raw != null) {
      const parsed = Number(raw);
      if (isValidTrendDay(parsed)) return parsed;
      if (parsed === 24) {
        localStorage.setItem(DASHBOARD_TREND_DAYS_KEY, String(DEFAULT_CONNECTION_TREND_DAYS));
      }
    }

    for (const key of LEGACY_TREND_DAYS_KEYS) {
      const legacyRaw = localStorage.getItem(key);
      if (legacyRaw == null) continue;
      const parsed = Number(legacyRaw);
      if (isValidTrendDay(parsed)) {
        localStorage.setItem(DASHBOARD_TREND_DAYS_KEY, String(parsed));
        return parsed;
      }
    }
  } catch {
    /* ignore */
  }

  return DEFAULT_CONNECTION_TREND_DAYS;
}

export function persistDashboardTrendDays(days: ConnectionTrendDayOption): void {
  try {
    localStorage.setItem(DASHBOARD_TREND_DAYS_KEY, String(days));
  } catch {
    /* ignore */
  }
}

export { CONNECTION_TREND_DAY_OPTIONS };
